export default {
  // Common
  common: {
    back: 'Back',
    confirm: 'Confirm',
    continue: 'Continue',
    cancel: 'Cancel',
    retry: 'Try Again',
    total: 'Total',
    profile: 'Profile',
    history: 'History',
    pleaseLogin: 'Please sign in first',
    my: 'Me',
    appName: 'Smart Menu Assistant',
    loading: 'Loading...',
    lang: 'Language',
    loadFailed: 'Loading failed',
    operationFailed: 'Operation failed',
    notSet: 'Not set',
    country: 'Country',
    all: 'All',
    searchPlaceholder: 'Search...',
    noMore: 'No more'
  },

  // Home
  home: {
    allFoods: 'All Foods',
    headline: {
      sub: 'Discover',
      main: '{country} cuisine'
    },
    articleTag: 'Guide',
    localGuideTitle: 'Local Guide',
    recommendedArticlesAll: 'All',
    hotTopics: 'Popular Topics',
    orderCallout: 'No more "this, this" ordering!',
    mustEatBadge: 'Must-Eat',
    countrySelect: {
      eyebrow: 'DESTINATIONS',
      title: 'Choose a Country',
      subtitle: 'Get better food inspiration and guides',
      footer: 'Switch anytime from the top left'
    },
    loadCountriesFailed: 'Failed to load countries'
  },

  // Favorites
  favorites: {
    title: 'Favorites',
    empty: 'No favorites yet',
    foods: 'Foods',
    articles: 'Articles'
  },

  articleList: {
    title: '{country} Guides',
    empty: 'No recommended guides yet'
  },

  // Dish Detail
  dishDetail: {
    quantity: 'Quantity',
    introduction: 'About this dish',
    loadingIntroduction: 'Getting dish info...',
    getIntroduction: 'Learn More',
    addToCart: 'Add {count} to Cart',
    selectQuantity: 'Choose quantity',
    addedToCart: '{count} added to cart',
    loadFailed: "Couldn't load dish info",
    noImage: 'Image not available',
    imageSearchEmpty: 'No exact dish image match found',
    imageSearchAction: 'Search images',
    aiImageGenerating: 'Creating AI image',
    generating: 'Generating'
  },

  // Tabbar
  tabbar: {
    home: 'Home',
    cameraOrder: 'Snap & Order',
    favorites: 'Favorites',
    profile: 'Me',
    camera: 'Scan',
    menu: 'Menu'
  },

  // Camera
  camera: {
    translate: 'Translate to',
    takeOrUpload: 'Take photo or upload',
    uploadHint: 'You can add up to 9 photos',
    addMore: 'Add more',
    order: 'Start Ordering',
    selectLanguage: 'Choose language',
    singleMode: 'Single',
    multiMode: 'Multiple',
    history: 'History',
    takePhotoError: "Couldn't take photo, try again",
    cameraUnsupported: 'Camera not available',
    cameraPermissionDenied: 'Camera access needed. Enable it in your settings',
    capture: 'Continue Taking Photos',
    tapToCapture: 'Tap to take photo',
    tapToStart: 'Tap to begin',
    readyToCapture: 'Scan menu',
    uploading: 'Uploading...',
    uploadFailed: 'Upload failed',
    pleaseCapture: 'Take a photo first',
    maxPhotosReached: 'You can only add 9 photos',
    photosAdded: '{count} photos added',
    confirmUpload: 'Upload',
    uploadMessage: 'Scanning {count} menu photos',
    startRecognition: 'Start scanning',
    confirmRecognition: 'Scan now',
    willRecognize: 'Ready to scan {count} menu photos',
    continueShooting: 'Keep going',
    prepareUpload: 'Getting ready...',
    compressingImage: 'Optimizing image...',
    compressionFailed: "Couldn't optimize image",
    useOriginal: 'Use original',
    takePhoto: 'Tap to Take Photo',
    selectFromGallery: 'Choose from Photos',
    operationFailed: 'Something went wrong, try again',
    processingPhoto: 'Processing...',
    leavingPageWarning: "Still processing photos. Leave anyway?",
    restoreInfoMissing: 'Found info for {count} photos but the images are gone. Please take new photos',
    addedAndSkipped: 'Added {added} photos, skipped {skipped} files that weren\'t images',
    remainingQuotaNotice: 'Dear user {phone}: Subscription validity: {days}',
    guide: {
      step1: 'Snap',
      step2: 'AI Scan & Translate',
      step3: 'Order'
    }
  },

  // Login
  login: {
    title: 'Sign In',
    phone: 'Phone',
    code: 'Code',
    phoneNumber: 'Phone Number',
    verifyCode: 'Verification Code',
    sendCode: 'Get Code',
    resend: 'Resend',
    login: 'Sign In',
    loggingIn: 'Signing in...',
    success: 'Welcome back!',
    failed: 'Sign in failed, try again',
    loginSuccess: 'Successfully signed in',
    loginFailed: "Couldn't sign in",
    phonePlaceholder: 'Your phone number',
    codePlaceholder: 'Enter code',
    phoneRequired: 'Phone number required',
    codeRequired: 'Code required',
    phoneInvalid: 'Check your phone number',
    codeInvalid: 'Code should be 4-6 digits',
    phoneError: 'Invalid phone number',
    codeError: 'Wrong code',
    codeSent: 'Code sent!',
    resendCode: 'Send again',
    countdown: 'Wait {count}s',
    retryAfter: 'Try again in {seconds}s',
    tooFrequent: 'Too many attempts. Wait a moment',
    dailyLimit: "You've reached today's limit",
    sendFailed: "Couldn't send code. Try again",
    agreeTips: 'By signing in, you agree to our Terms and Privacy Policy'
  },

  // Menu
  menu: {
    title: 'Menu',
    cartTitle: 'Your Cart',
    checkout: 'Place Order',
    totalItems: '{count} items',
    clearCart: 'Clear All',
    emptyCart: 'Your cart is empty',
    aiRecommend: 'Get AI Suggestions',
    addToCart: 'Add to Cart',
    viewDetail: 'See Details',
    price: 'Price',
    quantity: 'Qty',
    currentMenu: 'Today\'s Menu',
    clearCartConfirm: 'Remove everything from your cart?',
    noMenuData: 'Scan a menu first',
    confirmButton: 'OK',
    cancelButton: 'Cancel',
    hint: 'Heads up',
    noMenuItemsFound: "Couldn't find any menu items"
  },

  // AI
  ai: {
    recommendedSets: 'Suggested Combos',
    dishCount: 'dishes',
    selectSetHint: 'Pick a combo',
    noSelectedDishes: 'Select some dishes first',
    setPrefix: 'Combo',
    others: 'More',
    diningOptions: 'Your Preferences',
    numberOfPeople: 'Party Size',
    dietaryPreferences: 'Dietary Needs',
    budgetRange: 'Budget',
    getRecommendation: 'Get AI Suggestions',
    noSpicy: 'Mild',
    vegetarian: 'Vegetarian',
    seafood: 'Seafood',
    meat: 'Meat Lover',
    loading: 'Creating your recommendations...',
    recommendationTitle: 'Perfect for You',
    tastePreference: 'Flavor Profile',
    budgetPerPerson: 'Per Person Budget',
    allergyWarning: 'Allergies & Restrictions',
    sweet: 'Sweet',
    sour: 'Sour',
    spicy: 'Spicy',
    bitter: 'Bitter',
    umami: 'Savory',
    light: 'Light',
    heavy: 'Rich',
    dairy: 'Dairy',
    eggs: 'Eggs',
    fish: 'Fish',
    shellfish: 'Shellfish',
    treeNuts: 'Tree Nuts',
    peanuts: 'Peanuts',
    wheat: 'Wheat',
    soy: 'Soy',
    selectOptions: 'Tell us your preferences',
    peopleCountError: 'Need at least 1 person',
    budgetRangeError: 'Budget must be a positive number',
    budgetMaxMinError: 'Maximum should be higher than minimum',
    submitFailed: "Couldn't submit. Try again",
    minBudget: 'Minimum',
    maxBudget: 'Maximum',
    to: 'to',
    yuan: '¥',
    recommendProgress: 'Finding Great Options',
    analyzing: 'Reading the menu...',
    generating: 'Creating suggestions...',
    recommendReason: 'Why We Recommend This',
    menuCombination: 'Your Combo',
    dietaryNotes: 'Good to Know',
    servingSize: 'Portions',
    viewDetail: 'Details',
    goToCheckout: 'Order Now',
    dish: 'serving',
    menuOption: 'Combo',
    recommendedDishes: 'Chef\'s Picks',
    categoryDishes: 'By Category',
    order: 'Order',
    orderConversation: 'Talk to Staff'
  },

  // Upload
  upload: {
    title: 'Scanning',
    uploading: 'Uploading...',
    recognizing: 'Reading menu...',
    translating: 'Translating...',
    generating: 'Almost done...',
    complete: 'Done!',
    failed: 'Failed',
    progress: 'Progress',
    detailsTitle: 'What We Found',
    retake: 'Take Again',
    retryUpload: 'Try Again',
    buyBenefits: 'Upgrade Benefits',
    uploadingNow: 'Uploading now',
    aiRecognizingImages: 'AI is reading your photos',
    aiTranslatingMenu: 'AI is translating the menu',
    dynamicCompression: 'Performing dynamic image compression',
    ocrEngineIntegration: 'Connecting the OCR image recognition engine',
    agentEngineBoot: 'Starting the intelligent agent engine',
    llmContextParsing: 'Running LLM contextual analysis',
    ragTargetLanguage: 'RAG aligning with the target language',
    cuisineRegionMapping: 'Mapping cuisine and regional styles',
    enhancedTranslation: 'Initializing enhanced translation',
    dishMetadataClassification: 'Classifying dish metadata',
    semanticUiConstruction: 'Constructing the semantic UI',
    confirmCancelTitle: 'Stop scanning?',
    confirmCancelMessage: 'Do you want to stop the current scan?',
    preparingCount: 'Getting {count} photos ready...',
    startUploadCount: 'Uploading {count} photos',
    processingComplete: 'All done',
    navigatingSoon: 'Loading...',
    processingCompleteAndNavigate: 'Done! Loading results...',
    createBackgroundTask: 'Setting things up...',
    noPhotoFound: 'No photos found',
    pleaseRetake: 'Please take new photos',
    dataParseFailed: "Couldn't read the data",
    photoDataParseFailed: "Couldn't process photos",
    photoDataFormatError: 'Photo format issue. Please take new photos',
    uploadFailedShort: 'Upload failed',
    failedShort: 'Failed',
    errorTryAgain: 'Something went wrong. Give it another try',
    menuNotFound: "Couldn't find a menu. Try a clearer photo",
    otherLlmErr: "Couldn't translate the menu",
    finalizing: 'Working hard to translate the menu',
    almostDone: 'Almost there, please wait'
  },

  // Error
  error: {
    network: 'Connection issue. Check your internet',
    server: "Server's having issues. Try again soon",
    timeout: 'Taking too long. Try again',
    unknown: 'Something went wrong',
    auth: 'Please sign in again',
    selectImage: 'Choose an image file',
    imageTooLarge: 'Image must be under 20MB',
    processPhotoFailed: "Couldn't process photo. Try again",
    processFileFailed: "Couldn't process file",
    pageStateError: 'Something went wrong. Please take new photos',
    processingPhotos: 'Working on your photos...',
    livePhotoNotSupported: 'Live Photos aren\'t supported. Choose a regular photo',
    microphonePermissionDenied: 'Microphone access needed. Allow it in your browser',
    microphoneNotFound: 'No microphone detected',
    microphoneInUse: 'Another app is using your microphone',
    microphoneConfigNotSupported: 'Your microphone doesn\'t support these settings',
    recordingNotSupported: 'Your browser doesn\'t support recording',
    recordingError: 'Recording failed',
    forbidden: 'You don\'t have permission',
    notFound: "Can't find what you're looking for",
    requestFailed: 'Request didn\'t go through',
    configError: 'Configuration issue'
  },

  // Order Conversation
  orderConversation: {
    title: 'Talk to Staff',
    menu_order: "Order",
    quantity: 'Quantity',
    translatedText: 'Translation',
    orderText: 'Order Details',
    userSpeak: 'Hold to speak',
    waiterSpeak: 'Hold to speak',
    customerSpeak: 'Hold to speak',
    waiterSpec: "Staff",
    customerSpec: "You",
    dish_detail: "Info",
    recording: 'Listening...',
    common_confirm: 'OK',
    customerRecording: 'Customer speaking...',
    recognizing: 'Processing speech...',
    translating: 'Translating...',
    recordingFailed: "Can't record. Check microphone settings",
    recognitionFailed: "Couldn't understand that",
    translationFailed: "Couldn't translate",
    recognitionResult: 'What we heard',
    blankAudio: "Too quick - speak a bit longer",
    noDishes: 'No items selected yet',
    assistantIntro: "Hi! I'm helping the customer order. They'd like these dishes. Hold the button below to ask questions - I'll translate for you."
  },

  // Profile
  profile: {
    title: 'Me',
    memberCard: {
      title: 'Member Benefits',
      dynamicTitle: 'You are currently a {status} user and enjoy these benefits:',
      feature1: ' Precise menu recognition',
      feature2: ' 20+ language translation',
      feature3: ' AI dining recommendations',
      feature4: ' Global cuisine insights',
      featureUsageTemplate: '{feature} ({count})',
      unlock: 'Unlock Now',
      unlockBenefits: 'Unlock Benefits'
    },
    menu: {
      privacy: 'Privacy',
      terms: 'Terms',
      feedback: 'Send Feedback',
      serviceStatus: 'Service Status',
      about: 'About'
    },
    redeem: {
      button: 'Redeem Benefits',
      title: 'Redeem Benefits',
      description: 'Enter your 12-character code to refresh your benefits.',
      placeholder: 'Enter redemption code',
      helper: 'Supports letters A-Z and numbers 0-9. Spaces are ignored; letter case does not matter.',
      submit: 'Redeem',
      cancel: 'Cancel',
      success: 'Benefits redeemed. Usage data will refresh shortly.',
      validation: {
        empty: 'Please enter your code first.',
        length: 'The code must be a 12-character letter and number combination.',
        format: 'The code format looks incorrect.',
        checksum: 'The code failed the quick check. Please verify and try again.'
      }
    },
    register: 'Delete Account',
    registerHint: 'Account deletion coming soon',
    logout: 'Sign Out',
    logoutConfirm: {
      title: 'Sign Out',
      message: 'Ready to sign out?'
    },
    logoutSuccess: 'Signed out'
  },

  subscription: {
    subtitle: 'AI MENU PASS',
    title: 'Unlock Smarter Dining Benefits',
    columns: {
      feature: 'What you get'
    },
    plans: {
      freeUser: 'Free User',
      trial: 'Free Trial',
      trialTag: 'Limited-time access',
      oneDay: '1-Day Subscription Plan',
      twoDay: '2-Day Subscription Plan',
      threeDay: '3-Day Subscription Plan',
      fiveDay: '5-Day Subscription Plan'
    },
    actions: {
      tryNow: 'Start trial',
      purchase: 'Buy now',
      continueTrial: 'Continue trial',
      trialUnavailable: 'Trial exhausted',
      renew: 'Renew now',
      subscribed: 'Already subscribed'
    },
    features: {
      validity: 'Remaining validity',
      price: 'Package price',
      usageCount: 'Included uses',
      aiTranslate: 'AI menu scan and translation (20+ languages)',
      aiTextDetail: 'AI dish write-ups',
      aiRichDetail: 'AI dish stories with visuals',
      aiRecommend: 'AI local set recommendations',
      aiOrder: 'AI ordering assistant',
      aiVoice: 'Continuous voice translation'
    },
    values: {
      days: '{count} days',
      lifetime: 'Lifetime',
      free: '0',
      price: '¥{amount} CNY',
      times: '{count} uses',
      notAvailable: '-',
      comingSoon: '- (rolling out soon)'
    },
    remarkTitle: 'How it works',
    remarksText:
      '1. Menu scanning is available in: Asia - Japan, South Korea, Thailand, Vietnam, Singapore, Malaysia, Indonesia, United Arab Emirates, Turkey; Europe - United Kingdom, France, Germany, Austria, Switzerland, Italy, Ireland, Spain, Portugal, Russia, Czechia, Hungary, Croatia, Netherlands, Romania, Sweden; North America - United States, Canada, Mexico; South America - Brazil, Argentina, Chile, Uruguay, Paraguay, Colombia, Venezuela, Panama, Peru, Ecuador; Other regions - Australia, New Zealand.' +
      '\nNote: Switzerland supports German, French, and Italian; Austria supports German only; South America (except Brazil) supports Spanish.' +
      '\n2. The content and rules shown here may be updated. Final interpretation follows local laws and protects user rights.',
    toast: {
      trialRedirect: 'Taking you to activate the full trial...',
      purchaseRedirect: 'Redirecting you to manage your membership...',
      contactAdmin: 'Please contact an administrator to activate your membership.',
      noQuota: 'You have no uses left. Visit “My” to purchase more access.',
      subscriptionExpired: 'Your membership has expired or run out of uses. Please renew in “My”.',
      trialExhausted: 'Your trial has been fully used. Please purchase a membership.',
      wechatRequired: 'Please open this page inside WeChat to complete payment.',
      paySuccess: 'Payment successful. Your benefits are refreshed.',
      payCancelled: 'Payment cancelled.',
      payFailed: 'Payment failed. Please try again shortly.',
      payPending: 'Payment is being confirmed. Check the order status later.',
      productUnavailable: 'This product is temporarily unavailable. Please try again later.'
    },
    currentBenefits: 'Current Plan',
    moreDetails: 'Details',
    remainingBenefits: 'Remaining',
    totalBenefits: 'Total',
    expireTime: 'Expires on',
    tabs: {
      compare: 'Compare',
      detail: 'Details'
    },
    upgradeTitle: 'Upgrade Your Plan',
    trialNoteTitle: 'Trial Info',
    trialNoteText: 'Trial members can experience menu translation and other features. Trial access does not affect subscription benefits.',
    statusDetail: {
      title: 'Plan Details',
      planName: 'Plan Name',
      startTime: 'Start Date',
      expireTime: 'End Date',
      totalCount: 'Total Uses',
      status: 'Status',
      statusMap: {
        pending: 'Pending',
        active: 'Active',
        invalid: 'Invalid/Expired'
      }
    },
    durations: {
      oneDay: '1 Day',
      twoDay: '2 Days',
      threeDay: '3 Days',
      fiveDay: '5 Days'
    },
    subscriptionSuffix: ' Subscription',
    subscriptionName: '{duration} Subscription',
    fiveDayDesc: '5-day validity',
    validityOnly: '{duration} validity',
    validityAndUsage: '{duration} validity, includes {usage}',
    usageCountSimple: 'uses'
  }
}
